import Ajv from "ajv";

const ajv = new Ajv();

export const validateJSON = (data: any) => {
  const schema = {
    type: "object",
    properties: {
      version: { type: "string" },
      schema: { type: "object" },
      uischema: {
        type: "object",
        properties: {
          type: {
            type: "string",
            enum: ["VerticalLayout", "HorizontalLayout"],
          },
        },
      },
      data: { type: "object" },
    },
    required: ["schema", "uischema"],
    additionalProperties: false,
  };

  const validate = ajv.compile(schema);

  validate(data);
  return validate.errors;
};
